// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"details_wrapper__s_r_l"};